module.exports = __webpack_public_path__ + "Euro_2020_link_Website_Banners-bd9c3ae8d110ad88cb77f435646e8d4f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/Euro_2020_link_Website_Banners.png
// module id = 1125
// module chunks = 1 2